import { useContext } from 'react'

import { MeetingTranscriptContext } from 'modules/meetings/lib/context/MeetingTranscriptContext'
import { type Transcript } from 'modules/meetings/lib/utils/transcriptUtils'

interface UseMeetingTranscriptReturn {
  transcript: Transcript | null
  loadingTranscript: boolean
  refetchTranscript: () => Promise<void>
}

export const useMeetingTranscript = (): UseMeetingTranscriptReturn => {
  const context = useContext(MeetingTranscriptContext)

  if (context === undefined) {
    throw new Error('useMeetingTranscript must be used within a MeetingTranscriptProvider')
  }

  const { transcript, loadingTranscript, refetchTranscript } = context

  return {
    transcript,
    loadingTranscript,
    refetchTranscript,
  }
}
